import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, getCurrentInstance, defineAsyncComponent, nextTick } from 'vue'
import { Button, DatePickerRangeInline } from 'ui-shared-components';
import { DATE_TIME_FORMATS, formatWithLocale } from '@white-label-helper/date-utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'date-range-picker',
  props: {
    startDateLabel: { default: '' },
    endDateLabel: { default: '' }
  },
  emits: ['open', 'close'],
  setup(__props: any, { emit }) {

const props = __props as { startDateLabel: string, endDateLabel: string };

const IconCalendar = defineAsyncComponent(() => import('@white-label-icon/icon-calendar'));

const form = ref({
  startDate: '' as Date | string,
  endDate: '' as Date | string,
})

const proxy = getCurrentInstance()?.proxy as Vue;



const computedStartDateLabel = computed(() => props.startDateLabel || proxy.$t('UI.dateRangeInput.label.startDate'));
const computedEndDateLabel = computed(() => props.endDateLabel || proxy.$t('UI.dateRangeInput.label.endDate'));

const startDateFormatted = computed(() => {
  return form.value.startDate && form.value.startDate instanceof Date
    ? formatWithLocale(form.value.startDate, DATE_TIME_FORMATS.weekday_day_month_year, proxy.$i18n.locale)
    : '';
});
const endDateFormatted = computed(() => {
  return form.value.endDate && form.value.endDate instanceof Date
    ? formatWithLocale(form.value.endDate, DATE_TIME_FORMATS.weekday_day_month_year, proxy.$i18n.locale)
    : '';
});

const datePickerOpened = ref(false);

const openDatePicker = async (input: 'start' | 'end') => {
  // If opening from the start date input, clear both dates
  if (input === 'start') {
    form.value.startDate = '';
    form.value.endDate = '';
  } else {
    // If opening from the end date input, clear only the end date
    form.value.endDate = '';
  }

  datePickerOpened.value = true;
  emit('open');

  // Wait for the DOM update, then focus on the flatpickr element
  await nextTick();
  const datepickerRangeInline = proxy.$refs['datepicker-range-inline'] as DatePickerRangeInline;
  if (datepickerRangeInline) {
    datepickerRangeInline.$refs['flatpickr-element']?.$el?.focus();
  }
};

const closeDatePicker = async () => {
  datePickerOpened.value = false;
  await nextTick();
  emit('close');

  // Focus on the end date button after closing the date picker
  if (!form.value.startDate) {
    const startDateButton = proxy.$el.querySelector('#date-time-picker__start-date') as HTMLButtonElement;
    startDateButton.focus();
  } else {
    const endDateButton = proxy.$el.querySelector('#date-time-picker__end-date') as HTMLButtonElement;
    if (endDateButton) {
      endDateButton.focus();
    }
  }
};

const onChangeDate = (dates: (Date | string)[]) => {
  const [date1, date2] = dates;
  form.value.startDate = date1 ?? '';
  form.value.endDate = date2 ?? '';
};

const headerLabel = computed(() => {
  if (!form.value.startDate) return proxy.$t('UI.dateRangeInput.placeholder.startDate');
  if (!form.value.endDate) return proxy.$t('UI.dateRangeInput.placeholder.endDate');
  return proxy.$t('UI.dateRangeInput.yourTripDates');
});

const minDate = computed(() => new Date());
const maxDate = computed(() => new Date(new Date().setFullYear(new Date().getFullYear() + 10)));



return { __sfc: true,IconCalendar, form, proxy, props, computedStartDateLabel, computedEndDateLabel, startDateFormatted, endDateFormatted, datePickerOpened, openDatePicker, closeDatePicker, onChangeDate, headerLabel, minDate, maxDate, emit, Button, DatePickerRangeInline }
}

})